import React, { Component } from 'react';
import classNames from 'classnames';

import styles from '../styles/Formula.module.css';

interface Props {
  /**
   * Action to execute when sub-formula is clicked.
   * Sub-formula looks disabled when this is undefined.
   */
  onClick: React.MouseEventHandler | undefined;
}

/**
 * Render a sub-formula.
 */
class Subformula extends Component<Props> {
  static defaultProps = {
    onClick: undefined
  };

  render() {
    return (
      <div
        className={classNames(styles.subformula, {
          [styles.active]: this.props.onClick !== undefined
        })}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Subformula;
